import { render, staticRenderFns } from "./open-banking-requests.vue?vue&type=template&id=a33d16c4"
import script from "./open-banking-requests.vue?vue&type=script&lang=js"
export * from "./open-banking-requests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports